import { combineReducers } from 'redux';
import AuthReducer from './AuthReducer';
import SignupReducer from './SignupReducer';
import ToolsReducer from './ToolsReducer';
import DemoReducer from './DemoReducer';
import EmployeeReducer from './EmployeeReducer';
import PartnerReducer from './PartnerReducer';
import PartnerSignupReducer from './PartnerSignupReducer';
import EmployerReducer from './EmployerReducer';
import GeneralReducer from './GeneralReducer';
import ReportReducer from './ReportReducer';
import ClaimReducer from './ClaimReducer';

const initialState = {}

const appReducer = combineReducers({
  auth: AuthReducer,
  signup: SignupReducer,
  tools: ToolsReducer,
  demo: DemoReducer,
  employee: EmployeeReducer,
  general: GeneralReducer,
  partner: PartnerReducer,
  partnersignup: PartnerSignupReducer,
  employer: EmployerReducer,
  report: ReportReducer,
  claim: ClaimReducer,
});

const rootReducer = (state, action) => {
  //handles logout globally for all reducers
  //had to change this so it doesnt log out of tools, will need each reduce to handle it's own LOGOUT method
  if(action.type === 'REFRESH_USER') {
     state = initialState;
  }
  return appReducer(state, action);
};

export default rootReducer;
